export default class Image {
  static fromJSON (json) {
    return new Image({
      url: json.url,
      tooltip: json.altText
    })
  }

  constructor ({ url, tooltip }) {
    this.url = url
    this.tooltip = tooltip
  }
}
